import { useContext, useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import useSession from '../hooks/useSession';
import { Link } from 'react-router-dom'
import authAPI from '../services/auth'
import { UserContext } from '../context/UserContext';
import Toast from './layout/Toast'
import { ErrorContext } from '../context/ErrorContext';

const Auth = () => {
  const [session, setSession] = useSession()
  const { user, setAuthUser, getL10nInstance } = useContext(UserContext)
  const [error, setError] = useState([])
  const [l10n, setL10n] = useState(null)
  const navigate = useNavigate();
  const { parseErrors } = useContext(ErrorContext)
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const {
    email,
    password,
  } = formData;
  const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value})
  const onSubmit = async (e) => {
    e.preventDefault()
    setError([]);
    try {
      const res = await authAPI.post({email, password})
      setSession(res.data.data.token);
      await getUserData(res.data.data.token)
    } catch (err) {
      const parsedErr = parseErrors(err.response.data.error)
      setError(parsedErr)
      // setError(err.response.data.errors.map(e => <p>{e.msg}</p>))
    }
  }

  useEffect(() => {
    (async () => {
      const instance = await getL10nInstance()
      setL10n(instance)
    })()
  }, [session, user])

  useEffect(() => {
    if (session && user) {
      roleManager(user)
    }
  }, [])

  const getUserData = async (jwt) => {
    const res = await authAPI.get({ jwt })
    setAuthUser(res.data.data)
    roleManager(res.data.data)
  }

  const roleManager = (user) => {
    switch (user.position) {
      case 'admin':
        return navigate('/register')    
      case 'am':
        return navigate('/widget#dashboard')  
      default:
        return navigate('/login')
    }
  }

  return (
    <>
      <section className='font-helveticaNeue w-3/5 m-auto my-10 text-[#152536]'>
        <h1 className='font-bold text-[40px] leading-[60px] text-center'>{l10n && l10n.getString('Sign In')}</h1>
        <p className='font-normal text-[#68717A] mt-4 text-center'>{l10n && l10n.getString('Welcome! Please sign in below to access your Bunny Studio projects.')}</p>
        <form className='mt-6 m-auto my-12 text-base bg-white w-[920px] h-[312px] rounded-2xl border border-[#CCCCCC]' onSubmit={e => onSubmit(e)}>
          <div className='m-8 mb-6'>
            <label htmlFor="email" className='block font-semibold'>{l10n && l10n.getString('Email')}*</label>
            <input id="email"
              className='block w-[856px] h-12 mr-6 my-2 px-[12px] py-[12px] border border-solid border-[#B6B7C0] rounded'
              type="email"
              placeholder="someone@email.com"
              onChange={ e => onChange(e) }
              name="email"
              required
            />
          </div>
          <div className='ml-8 m-6'>
            <label htmlFor="password" className='block font-semibold'>{l10n && l10n.getString('Password')}*</label>
            <input id="password"
              className='block w-[856px] h-12 mr-6 my-2 px-[12px] py-[12px] border border-solid border-[#B6B7C0] rounded'
              type="password"
              onChange={ e => onChange(e) }
              placeholder={l10n && l10n.getString("Password")}
              name="password"
            />
          </div>
          <input
            type="submit"
            className="ml-8 h-12 w-[178px] rounded-[25px] font-semibold text-base text-white bg-[#6A4278] hover:bg-[#854f99] px-4 py-2 rounded"
            value={l10n && l10n.getString("Sign in")}
          />
        </form>
      </section>
      <Toast toast={error} time={3000} />
    </>
  )
}

export default Auth